import axios from 'axios';
import { Service } from 'axios-middleware';
import { redirectToLogin } from '../actions/user';

function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
}

export function registerAjaxAddAuthorizationHeader() {
    const service = new Service(axios);

    service.register({
        onRequest(config) {
            //document.cookie
            config.headers['Authorization'] = getCookie('.NEWSAUTH');

            return config;
        }
    });
};


export function registerAjaxNotAuthorizedRedirect() {
    const service = new Service(axios);

    service.register({
        onResponseError(error) {
            if(error && error.response && error.response.status === 401 && !error.config.url.endsWith('/login-page')) {
                // redirectToLogin();
                const search = window.location.search;
                redirectToLogin(`/${search}`);
            }
            return error;
        }
    });
};


// WEBPACK FOOTER //
// ./src/middlewares/axios.js